export interface IManifest {
	name: string;
	html: string;
	assets: {
		css?: string[];
		js?: string[];
	};
}
